module.exports = __webpack_public_path__ + "media/images/landing/banner_01.es-c9d5b9a9361ca89b0e13718ed3e431a7.png";